import { z } from 'zod';
import { DOMAINS, categoryDomain, isDangerCategory } from './referentiels-metier';
export const schemaSignalementPublic = z
  .object({
    organisation_id: z.string().uuid(),
    province_id: z.string().uuid(),
    domaine: z.enum(DOMAINS),
    categorie: z.string().max(60),
    description: z.string().trim().min(5).max(2000),
    localisation: z.string().trim().min(3).max(250),
    securite_lue: z.boolean().default(false),
    site_web: z.string().max(0).default(''),
  })
  .superRefine((d, c) => {
    if (categoryDomain(d.categorie) !== d.domaine)
      c.addIssue({
        code: 'custom',
        path: ['categorie'],
        message: 'Catégorie incompatible avec le service',
      });
    if (isDangerCategory(d.categorie) && !d.securite_lue)
      c.addIssue({
        code: 'custom',
        path: ['securite_lue'],
        message: 'Prenez connaissance des consignes de sécurité',
      });
  });
export const schemaSuiviPublic = z.object({
  code: z.string().regex(/^[0-9a-f-]{36}\.[A-Za-z0-9_-]{43}$/),
});
export const schemaRetourPublic = schemaSuiviPublic
  .extend({
    note: z.number().int().min(1).max(5),
    commentaire: z.string().trim().max(1000).default(''),
  })
  .strict();
